import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import { useState } from "react";
import axios from "axios";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default function SearchableMapPicker({ value, onChange }) {
  const [position, setPosition] = useState(value || [20.5937, 78.9629]);
  const [zoom, setZoom] = useState(5);
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  // ---- search suggestion from OSM ----
  const fetchSuggestions = async (text) => {
    setQuery(text);
    if (!text || text.length < 3) {
      setSuggestions([]);
      return;
    }
    try {
      const res = await axios.get(
        "https://nominatim.openstreetmap.org/search",
        {
          params: {
            q: text,
            format: "json",
            addressdetails: 1,
            limit: 5,
          },
        }
      );
      setSuggestions(res.data);
    } catch (err) {
      console.error("Search failed", err);
    }
  };

  const handleSelectSuggestion = (s) => {
    const lat = parseFloat(s.lat);
    const lon = parseFloat(s.lon);
    setSuggestions([]);
    setQuery(s.display_name);
    setPosition([lat, lon]);
    setZoom(14);
    onChange({ lat, lng: lon, address: s.display_name });
  };

  const LocationMarker = () => {
    useMapEvents({
      click(e) {
        const { lat, lng } = e.latlng;
        setPosition([lat, lng]);
        setZoom(14);
        onChange({ lat, lng });
      },
    });
    return <Marker position={position} />;
  };

  return (
    <div className="w-full space-y-2">
      {/* Search Bar */}
      <div className="relative">
        <input
          type="text"
          value={query}
          onChange={(e) => fetchSuggestions(e.target.value)}
          placeholder="Search location..."
          className="w-full border rounded-lg p-2"
        />
        {suggestions.length > 0 && (
          <ul
            className="absolute z-[1000] bg-white border rounded-lg shadow-lg 
               max-h-40 overflow-y-auto w-full mt-1"
          >
            {suggestions.map((s) => (
              <li
                key={s.place_id}
                onClick={() => handleSelectSuggestion(s)}
                className="px-3 py-2 hover:bg-blue-50 cursor-pointer text-sm"
              >
                {s.display_name}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Map */}
      <div className="rounded-lg overflow-hidden h-64 border">
        <MapContainer
          center={position}
          zoom={zoom}
          style={{ height: "100%", width: "100%" }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <LocationMarker />
        </MapContainer>
      </div>
    </div>
  );
}
